import { render, staticRenderFns } from "./scheduleDB-admission.vue?vue&type=template&id=19fe77a2&"
import script from "./scheduleDB-admission.vue?vue&type=script&lang=js&"
export * from "./scheduleDB-admission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports